/* bristm-cta — section script (loaded only where the section renders) */
(function () {
  function initCta(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-b-cta-media]').forEach(function (media) {
      if (media.dataset.bCtaBound) return;
      media.dataset.bCtaBound = '1';
      if (!('IntersectionObserver' in window)) {
        media.classList.add('is-in');
        return;
      }
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              media.classList.add('is-in');
              io.disconnect();
            }
          });
        },
        { threshold: 0.15 }
      );
      io.observe(media);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initCta(document);
    });
  } else {
    initCta(document);
  }
  document.addEventListener('shopify:section:load', function (e) {
    initCta(e.target);
  });
})();
